export default __webpack_public_path__ + "static/media/Itinerary.23d97584.svg";